import { Color } from '@/constants/color';
import Button from '@/ui/components/Button';
import Heading from '@/ui/components/Heading';

interface PendingAccessProps {
  onDismiss: () => void;
}

function PendingAccess({ onDismiss }: PendingAccessProps) {
  return (
    <article className="flex flex-col items-center justify-center flex-1 p-6">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-lg border border-gray-100 p-8 flex flex-col items-center gap-6">
        <img
          src="/images/members/header-logo-light.svg"
          alt="Affect Therapeutics"
          className="h-12 w-auto dark:hidden"
        />
        <img
          src="/images/members/header-logo.svg"
          alt="Affect Therapeutics"
          className="h-12 w-auto hidden dark:block"
        />

        <div className="text-center flex flex-col gap-2">
          <Heading value={2} text="Your account isn't set up yet" className="text-gray-900" />
          <p className="text-sm text-gray-500">
            You&apos;ve signed in successfully, but your account hasn&apos;t been provisioned for
            staff access. Contact your administrator.
          </p>
        </div>

        <Button onClick={onDismiss} color={Color.GREEN} className="w-full justify-center">
          Back to sign in
        </Button>

        <p className="text-xs text-gray-400">
          &reg; {new Date().getFullYear()} Affect Therapeutics &bull; HIPAA Compliant
        </p>
      </div>
    </article>
  );
}

export default PendingAccess;
